import { render, staticRenderFns } from "./SMSMessageItem.vue?vue&type=template&id=cde03e10&"
import script from "./SMSMessageItem.vue?vue&type=script&lang=js&"
export * from "./SMSMessageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports